import React from 'react';
import { useHistory } from 'react-router-dom';

export default function ShortcutsSettings() {
  const history = useHistory();

  const go = ({ tab = 'Settings', settingsSubTab = null }) => {
    const params = new URLSearchParams();
    params.set('tab', tab);
    if (settingsSubTab) params.set('settingsSubTab', settingsSubTab);
    history.push(`/control-panel?${params.toString()}`);
  };

  const cards = [
    {
      title: '🔗 Connect your online accounts',
      subtext: 'Connect Google, Facebook, Instagram and other platforms to Suitestream.tv.',
      onClick: () => go({ tab: 'Settings', settingsSubTab: 'Integrations' }),
    },
    {
      title: '📺 Control your TVs',
      subtext: 'Remote control TVs, set-top boxes, and apps from Suitestream.tv.',
      onClick: () => go({ tab: 'Settings', settingsSubTab: 'Devices' }),
    },
    {
      title: '🔊 Add a background music system',
      subtext: 'Connect your house sound system or PA.',
      onClick: () => go({ tab: 'Settings', settingsSubTab: 'Devices' }),
    },
    {
      title: '📡 Set up captive portal Wi‑Fi',
      subtext: 'Collect customer information through your venue Wi‑Fi.',
      onClick: () => go({ tab: 'Wi-Fi Settings' }),
    },
    {
      title: '🖼 Upload your own content',
      subtext: 'Add images and videos to play on screens or use in campaigns.',
      onClick: () => go({ tab: 'Creative Studio' }),
    },
    {
      title: '🎯 Create your first campaign',
      subtext: 'Use your marketing kit to generate ads and promotions.',
      onClick: () => go({ tab: 'Creative Studio' }),
    },
  ];

  return (
    <div className="settings-section">
      <h3 className="settings-section-title">Shortcuts</h3>
      <div className="shortcuts-grid">
        {cards.map((card) => (
          <button key={card.title} type="button" className="shortcut-card" onClick={card.onClick}>
            <div className="shortcut-title">{card.title}</div>
            <div className="shortcut-subtext">{card.subtext}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
